import { Injectable, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DashboardService {
  private API_URL: string;

  constructor(private http: HttpClient, @Inject('API_URL') apiUrl: string) {
    this.API_URL = apiUrl;
  }

  getEmbeddedUrl(dashboardId: string, contentId: string, isInternalAccess: boolean = false): Observable<{ embed_url: string }> {
    const endpoint = '/dashboard/embedURL';

    const url = `${this.API_URL}${endpoint}?dashboardId=${dashboardId}&contentId=${contentId}`;
    return this.http.get<{ embed_url: string }>(url)
  }
}
